import { coordenadaState } from "../../states/coordenadaState";
import { coordenadaTypes } from "../../types/coordenadaTypes";

export const coordenadasReducer = ( state = coordenadaState, action ) => {
    switch ( action.type ) {
		    case coordenadaTypes.SET_COORDENADA:
            return { ...state, ...action.payload  };
        default:
            return { ...state };
    }
}
